<template>
  <div class="w-full p-6">
    <div v-if="contentType === 'Text'">
      <vs-input
        class="inputx w-full"
        placeholder="Placeholder"
        v-model="content"
      />
    </div>
    <div v-if="contentType === 'Button'">
      <vs-input
        class="inputx w-full"
        placeholder="Placeholder"
        v-model="content"
      />
    </div>
    <div v-if="contentType === 'Textfield'">
      <el-input
        type="textarea"
        :rows="6"
        class="inputx w-full"
        placeholder="Placeholder"
        v-model="content"
      />
      <!-- 
      <vue-editor
        class="bg-white w-full"
        placeholder="Placeholder"
        v-model="content"
      /> -->
      <!-- <vue-editor
        class="inputx w-full"
        placeholder="Placeholder"
        v-model="content"
      /> -->
    </div>
    <div v-if="contentType === 'Image'">
      <div class="w-full">
        <div
          class="relative w-full h-img cursor-pointer rounded-lg mb-3 hoverimg"
        >
          <div
            class="absolute bg-trans top-0 left-0 w-full imgd items-center h-img justify-center"
          >
            <!-- <FeatherIcon icon="user" /> -->
            <div class="flex justify-center h-full items-center">
              <div class="text-center">
                <img
                  src="https://nimbuscluster.blob.core.windows.net/server01/admin/images/noun-upload.svg"
                  alt="image"
                  class="w-10 h-10 mx-auto"
                />
                <p class="font-semibold text-dark">Please Upload Image</p>
              </div>
            </div>
          </div>

          <div class="flex h-img justify-center w-full">
            <img
              :src="getImage(content)"
              class="w-full h-img object-cover m-auto"
              alt="image"
            />
          </div>

          <div class="absolute top-0 w-full left-0">
            <input
              type="file"
              class="textshow-an w-full h-img p-4"
              @change="fileUpload"
            />
          </div>
        </div>
        <div>
          <vs-button
            color="success"
            class="mt-4 w-full"
            type="filled"
            @click="upload"
            >upload</vs-button
          >
        </div>
        <!-- <label for="textarea-default">Content </label> -->
      </div>
    </div>
    <div v-if="contentType === 'Cards'">
      <swiper
        :options="swiperOption"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
        :key="$vs.rtl"
      >
        <swiper-slide
          v-for="(item, index) in loopData"
          :key="item"
          class="relative flex justify-start p-3"
        >
          <div class="mb-1 w-full shadow-cus p-3 rounded-lg">
            <div class="flex items-center gap-10 mb-1 justify-between">
              <div class="">
                <span for="textarea-default"
                  >{{ `${contentType} ${index + 1}` }}
                </span>
              </div>
              <!-- <div class="">
                <feather-icon
                  v-if="index === 0"
                  size="15"
                  icon="PlusCircleIcon"
                  class="cursor-pointer textsecondary"
                  @click="increaseLoopData(item, index)"
                />
                <feather-icon
                  v-if="index > 0"
                  size="15"
                  icon="Trash2Icon"
                  class="cursor-pointer text-danger"
                  @click="decreaseLoopData(item, index)"
                />
              </div> -->
            </div>
            <div
              v-for="(subItem, subIndex) in item"
              :key="subItem"
              class="mb-1"
            >
              <div class="d-flex align-items-center gap-10px">
                <!-- <div class="w-50">
              <label for="textarea-default">Type</label>
              <v-select
                v-model="subItem.type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="Select"
                placeholder="select types"
                :options="selectedTypes1()"
              />
            </div> -->
                <div class="w-50" v-if="subItem.type === 'Text'">
                  <label for="textarea-default">Content </label>
                  <vs-input
                    id="h-first-name"
                    v-model="subItem.fieldValue"
                    placeholder="Enter..."
                    @input="updateLoop()"
                  />
                </div>
                <div class="w-50" v-if="subItem.type === 'Link'">
                  <label for="textarea-default">Link </label>
                  <vs-input
                    id="h-first-name"
                    v-model="subItem.fieldValue"
                    placeholder="Enter..."
                    @input="updateLoop()"
                  />
                </div>
                <div class="w-50" v-if="subItem.type === 'Textfield'">
                  <label for="textarea-default">Content </label>
                  <vs-input
                    id="h-first-name"
                    v-model="subItem.fieldValue"
                    placeholder="Enter..."
                    @input="updateLoop()"
                  />
                </div>
                <div class="w-full" v-if="subItem.type === 'Image'">
                  <div
                    class="relative w-full h-img cursor-pointer rounded-lg mb-3 hoverimg"
                  >
                    <div
                      class="absolute bg-trans top-0 left-0 w-full imgd items-center h-img justify-center"
                    >
                      <!-- <FeatherIcon icon="user" /> -->
                      <div class="flex justify-center h-full items-center">
                        <div class="text-center">
                          <img
                            src="https://nimbuscluster.blob.core.windows.net/server01/admin/images/noun-upload.svg"
                            alt="image"
                            class="w-10 h-10 mx-auto"
                          />
                          <p class="font-semibold text-dark">
                            Please Upload Image
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="flex h-img justify-center w-full">
                      <img
                        :src="
                          subItem.newFile
                            ? subItem.fieldValue
                            : getImage(subItem.fieldValue)
                        "
                        class="w-full h-img object-cover m-auto"
                        alt="image"
                      />
                    </div>

                    <div class="absolute top-0 w-full left-0">
                      <input
                        type="file"
                        class="textshow-an w-full h-img"
                        @change="fileIndex(subIndex, index)"
                        @input="fileUploader"
                      />
                    </div>
                  </div>
                  <div>
                    <vs-button
                      color="primary"
                      class="mt-0 w-full"
                      type="filled"
                      @click="uploadImage(index, subIndex)"
                      >upload</vs-button
                    >
                  </div>
                  <!-- <label for="textarea-default">Content </label> -->
                </div>

                <!-- <div>
              <feather-icon
                v-if="subIndex > 0"
                size="15"
                icon="Trash2Icon"
                class="cursor-pointer mt-2 text-danger"
                @click="removeLoopData(item, index, subIndex)"
              />
            </div> -->
              </div>
              <div class="mt-1 cursor-pointer" v-if="!subItem.loopLink">
                <div class="flex items-center" @click="subItem.loopLink = true">
                  <feather-icon
                    size="15"
                    icon="PlusIcon"
                    class="textsecondary"
                  /><span class="textsecondary mini-marleft2">Add link</span>
                </div>
              </div>
              <b-form-group v-if="subItem.loopLink">
                <label for="textarea-default">Link</label>
                <div class="flex align-items-center mt-1 cursor-pointer">
                  <vs-input
                    id="h-first-name"
                    v-model="subItem.link"
                    placeholder="Enter..."
                    class=""
                  />
                  <feather-icon
                    v-if="subItem.loopLink"
                    svgClasses="w-6 h-6"
                    icon="Trash2Icon"
                    class="cursor-pointer text-danger ml-1"
                    @click="
                      () => {
                        (subItem.loopLink = false), (subItem.link = '');
                      }
                    "
                  />
                </div>
              </b-form-group>
            </div>
            <!-- <div class="mt-1">
          <b-button
            variant="primary"
            class="mr-1 w-100 h-25px"
            @click="addLoopData(item, index, subIndex)"
          >
            Add
          </b-button>
        </div> -->
          </div></swiper-slide
        >
      </swiper>
    </div>

    <vs-button
      color="primary"
      class="mt-6 w-full"
      type="filled"
      @click="onUpdate"
      >Submit</vs-button
    >
  </div>
</template>
<script>
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      content: "",
      contentType: "",
      imageSrc: "",
      loopData: [
        [
          {
            fieldValue: "",
            type: "",
            link: "",
            loopLink: false,
            newFile: false,
          },
        ],
      ],
      index1: 0,
      index2: 0,
      cmsData: "",
      swiperOption: {
        slidesPerView: 1.5,
        spaceBetween: 0,
        // autoplay: 5000,
        // speed: 800,
        // breakpoints: {
        //   1600: {
        //     slidesPerView: 4,
        //     spaceBetween: 25,
        //   },
        //   1300: {
        //     slidesPerView: 3,
        //     spaceBetween: 20,
        //   },
        //   900: {
        //     slidesPerView: 2,
        //     spaceBetween: 15,
        //   },
        //   640: {
        //     slidesPerView: 2,
        //     spaceBetween: 10,
        //   },
        //   576: {
        //     slidesPerView: 1,
        //     spaceBetween: 10,
        //   },
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      file: "",
      // customToolBar: [["bold", "italic"]],
    };
  },

  methods: {
    init() {
      this.contentType = this.cmsData.contentType;
      if (this.cmsData.hasOwnProperty("loop") && this.cmsData.loop.length) {
        let data = this.cmsData.loop;
        let cards = [];
        for (let i = 0; i < data.length; i++) {
          let cardElements = Object.keys(data[i]);
          let elementIndex = 0;
          cardElements.forEach((x) => {
            console.log(parseInt(x.slice(-1)));
            if (parseInt(x.slice(-1)) > elementIndex)
              elementIndex = parseInt(x.slice(-1));
          });
          let card = [];
          for (let j = 1; j <= elementIndex; j++) {
            let payload = {};

            payload["fieldValue"] = data[i][`field${j}`];
            payload["type"] = data[i][`fieldType${j}`];
            payload["id"] = data[i][`fieldId${j}`];
            payload["link"] = data[i][`fieldLink${j}`]
              ? data[i][`fieldLink${j}`]
              : "";
            payload["loopLink"] = data[i][`fieldLink${j}`] ? true : false;
            payload["newFile"] = false;
            payload["file"] = "";
            card.push(payload);
          }
          cards.push(card);
        }
        this.loopData = cards;
      } else {
        this.content = this.cmsData.content;
      }
    },
    fileIndex(a, b) {
      console.log(a, b);
      this.index1 = b;
      this.index2 = a;
    },
    async fileUploader(e) {
      let file = e.target.files[0];
      let b64 = await this.convertToBase64(file);
      this.loopData[this.index1][this.index2].newFile = true;
      this.loopData[this.index1][this.index2].fieldValue = b64;
      this.loopData[this.index1][this.index2].file = file;
      this.updateLoop();
    },

    async uploadImage(a, b) {
      let formData = new FormData();
      formData.append("path", process.env.VUE_APP_COMMUNITY_NAME + "/Assets");
      formData.append("files", this.loopData[a][b].file);
      let { data } = await this.$store.dispatch("cms/uploadImage", formData);
      if (data) {
        this.loopData[this.index1][this.index2].fieldValue = data[0];
        this.loopData[this.index1][this.index2].newFile = false;
        this.updateLoop();
      }
    },

    async upload() {
      let formData = new FormData();
      formData.append("path", process.env.VUE_APP_COMMUNITY_NAME + "/Assets");
      formData.append("files", this.file);
      let { data } = await this.$store.dispatch("cms/uploadImage", formData);
      if (data.length) {
        console.log(data);
        // this.$store.commit("cms/UPDATE_PAGES", {
        //   page: this.cmsData.pageName,
        //   id: this.selectedId,
        //   data: data[0],
        // });
        this.content = data[0];
      }
    },

    async fileUpload(e) {
      let file = e.target.files[0];
      let b64 = await this.convertToBase64(file);
      this.content = b64;
      this.file = file;
    },

    updateLoop() {
      console.log("update loop");
      let updatedData = [];
      for (let i = 0; i < this.loopData.length; i++) {
        let payload = {};
        for (let j = 0; j < this.loopData[i].length; j++) {
          payload[`field${j + 1}`] = this.loopData[i][j].fieldValue;
          payload[`fieldType${j + 1}`] = this.loopData[i][j].type;
          this.loopData[i][j].link
            ? (payload[`fieldLink${j + 1}`] = this.loopData[i][j].link)
            : "";
          payload[`fieldId${j + 1}`] = !this.loopData[i][j].id;
        }
        updatedData.push(payload);
      }
      this.$store.commit("cms/UPDATE_PAGES", {
        page: this.cmsData.pageName,
        id: this.selectedId,
        data: updatedData,
      });
    },
    convertToBase64(file) {
      return new Promise(async (resolve) => {
        let reader = new FileReader();
        await reader.readAsDataURL(file);

        reader.onloadend = await function () {
          resolve(reader.result);
        };
      });
    },
    async onUpdate() {
      let payload = {
        _id: this.cmsData._id,
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
        contentType: this.cmsData.contentType,
      };

      if (
        this.content != this.cmsData.content &&
        !this.content.includes("data:")
      ) {
        Object.assign(payload, { content: this.content });
      }

      if (this.loopData.length)
        Object.assign(payload, { loopData: this.loopData });
      if (this.link) Object.assign(payload, { link: this.link });
      let update = await this.$store.dispatch("cms/updateClientCms", payload);

      if (update) {
        this.$emit("closePopup");
        this.content = "";
        this.contentType = "";
      }
    },
    getImage(image) {
      if (image && image && image.includes("data:image/")) {
        return image;
      } else {
        if (image) {
          return `${process.env.VUE_APP_STORAGE_URL}${image}`;
        } else {
          return "https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg";
        }
      }
    },
  },

  watch: {
    async isShowCMS(value) {
      console.log(value && this.selectedId, "cms");
      if (value && this.selectedId) {
        let payload = {
          projectName: process.env.VUE_APP_COMMUNITY_NAME,
          elementId: this.selectedId,
        };
        let { data } = await this.$store.dispatch(
          "cms/getClientCmsById",
          payload
        );
        this.cmsData = data[0];
        console.log(data, "cms");
        this.init();
      }
    },

    content(value) {
      if (this.isShowCMS) {
        console.log(value, this.cmsData.content);
        this.$store.commit("cms/UPDATE_PAGES", {
          page: this.cmsData.pageName,
          id: this.selectedId,
          data: value,
        });
      }
    },
  },

  async mounted() {
    // console.log("cms mounted");

    if (this.isShowCMS && this.selectedId) {
      let payload = {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
        elementId: this.selectedId,
      };
      let { data } = await this.$store.dispatch(
        "cms/getClientCmsById",
        payload
      );
      this.cmsData = data[0];
      console.log(data, "cms");
      this.init();
    }
  },

  props: {
    isShowCMS: {
      type: Boolean,
    },
    selectedId: {
      type: String,
    },
  },
  components: {
    swiper,
    swiperSlide,
    VueEditor,
  },
};
</script>
